// extracted by mini-css-extract-plugin
export default {"main":"home-page_main__pCMIz"};